<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.14969 4.58856H8.37807C5.92903 4.58856 3.94336 6.57401 3.94336 9.02318V16.2692C3.94336 18.7184 5.92903 20.7038 8.37807 20.7038C10.6019 20.7038 13.3993 20.7038 15.6241 20.7038C18.0731 20.7038 20.0588 18.7184 20.0588 16.2692V9.02318C20.0588 6.57401 18.0731 4.58856 15.6241 4.58856H14.8514V3.91238C14.8514 3.56715 14.5712 3.28686 14.2259 3.28686C13.8806 3.28686 13.6004 3.56715 13.6004 3.91238V4.58856H10.4007V3.91238C10.4007 3.56715 10.1205 3.28686 9.77521 3.28686C9.42992 3.28686 9.14969 3.56715 9.14969 3.91238V4.58856ZM18.8077 10.8971V16.2692C18.8077 18.0274 17.3816 19.4528 15.6241 19.4528C13.3993 19.4528 10.6019 19.4528 8.37807 19.4528C6.6196 19.4528 5.1944 18.0274 5.1944 16.2692V10.8971H18.8077ZM9.14969 5.8396H8.37807C6.6196 5.8396 5.1944 7.26494 5.1944 9.02318V9.64607H18.8077V9.02318C18.8077 7.26494 17.3816 5.8396 15.6241 5.8396H14.8514V6.51579C14.8514 6.86102 14.5712 7.14131 14.2259 7.14131C13.8806 7.14131 13.6004 6.86102 13.6004 6.51579V5.8396H10.4007V6.51579C10.4007 6.86102 10.1205 7.14131 9.77521 7.14131C9.42992 7.14131 9.14969 6.86102 9.14969 6.51579V5.8396Z"
      fill="#757575"
    />
  </svg>
</template>
<script>
export default {
  name: 'Calendar'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
